import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import clsx from 'clsx';
import NewDialog from '../Applicants/NewDialog';
import { ANA, KYOTANGO } from '../../core/variables';
import { AnaAlert } from '../Features/Business/ana';
import ActionBar from '../../core/AppBar/ActionBar';
import Description from '../components/Pcr/Description';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import { useSnackbar } from 'notistack';
import { AuthDialogContext } from '../components/AuthDialog/AuthDialogContextProvider';

const useStyles = makeStyles((theme) => ({
  dialogAlertRoot: {
    padding: theme.spacing(2, 0),
  },
  dialogAlert: {
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  pcrAlert: {
    width: '100%',
    maxWidth: theme.breakpoints.values.md,
    lineHeight: 1.8,
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
}));

const Application = ({
  authenticated,
  title,
  planId,
  businessName,
  businessFeatures = [],
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { handleOpen: handleOpenAuthDialog } = useContext(AuthDialogContext);

  const [visibility, setVisibility] = React.useState(true);

  const handleSuccess = ({ terms, message }) => {
    message && enqueueSnackbar(message, { variant: 'success' });
    setVisibility(terms.length > 0);
  };

  if (!visibility) return <div />;
  const isBusinessKyotango = businessFeatures.includes(KYOTANGO);

  return (
    <ActionBar
      selector="footer"
      actions={[
        {
          ButtonProps: {
            id: 'applicationButton',
            children: T.translate('applyForOtetsutabi'),
            variant: 'contained',
            color: 'primary',
            onClick: (openDialog) =>
              authenticated ? openDialog() : handleOpenAuthDialog(),
          },
          DialogComponent: NewDialog,
          DialogProps: {
            ActionButtonProps: { id: 'applyPlanTerm' },
            CancelButtonProps: { id: 'cancelPlanApplication' },
            DialogTitleIconButtonProps: { id: 'closePlanApplication' },
            plan: title,
            planId,
            businessName,
            onSuccess: handleSuccess,
            otherContent: (
              <>
                {businessFeatures.includes(ANA) && (
                  <AnaAlert
                    classes={{
                      root: classes.dialogAlertRoot,
                      alert: classes.dialogAlert,
                    }}
                  />
                )}
              </>
            ),
          },
        },
      ]}
    />
  );
};

Application.propTypes = {
  authenticated: PropTypes.bool,
  title: PropTypes.string,
  planId: PropTypes.any,
  businessName: PropTypes.string,
  businessFeatures: PropTypes.arrayOf(PropTypes.string),
};

export default Application;
